import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/app/components/footer/social/Social.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/app/components/footer/copyright/Copyright.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www-local/frontend/lides/lides-sk-01/components/_other/metaPixel/MetaPixel.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","MICRODATA_ORGANIZATION"] */ "/var/www-local/frontend/lides/lides-sk-01/grandus-lib/components-atomic/MicroData.js");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/node_modules/next/font/google/target.css?{\"path\":\"app/layout.jsx\",\"import\":\"Bricolage_Grotesque\",\"arguments\":[{\"subsets\":[\"latin-ext\"],\"weight\":[\"300\",\"400\",\"500\",\"700\",\"800\"]}],\"variableName\":\"figtree\"}");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/styles/style.scss");
